/*
 * @Author: gongyu
 * @Description: 
 * @Date: 2022-12-12 17:16:07
 * @LastEditors: gongyu
 * @LastEditTime: 2025-12-15 19:21:47
 */
const apiUrl = 'https://feed.bz.mgtv.com'
const MGECOM = 'https://mgecom.api.mgtv.com'
const MGESQ = 'https://mgesq.api.mgtv.com'
const MGERANK = 'https://mgrank.api.mgtv.com'

export const FeedInfoUrl = MGESQ + '/feed/info'

export const FeedTagInfoUrl = MGESQ + '/feed/tag/info' // 标签详情

export const GoodsListUrl = MGESQ + '/feed/goods/list'

export const AddCartUrl = MGECOM + '/collect/addcart' // 商品加入购物车

export const CommentListUrl = MGESQ + '/comment/list'
export const CommentListUrlNew = MGESQ + '/comment/list/v2'

export const CommentUpUrl = MGESQ + '/comment/up' // 评论点赞

export const CollectAddUrl = MGESQ + '/feed/collect/add' // 动态收藏

export const CollectDelUrl = MGESQ + '/feed/collect/del' // 动态取消收藏

export const PraiseAddUrl = MGESQ + '/feed/praise/add' // 动态点赞

export const PraiseDelUrl = MGESQ + '/feed/praise/del' // 动态取消点赞

export const CommentReplyListUrl = MGESQ + '/comment/replylist' // 获取回复评论列表

export const CommentAddUrl = MGESQ + '/comment/add' // 发布评论

export const AddFollowUrl = MGESQ + '/feed/fans/addFollow' // 关注

export const RemoveFollowUrl = MGESQ + '/feed/fans/removeFollow' // 取消关注

export const UserIneractUrl = MGESQ + '/feed/user/interact' // 动态内容 点赞、收藏 状态 （获取用户对某一条动态的 点赞收藏状态）

export const FeedDeleteUrl = MGESQ + '/feed/delete' // 删除动态

export const CommentReportAdd = MGESQ + '/feed/report/add' //举报评论

export const LiveReportTypes = MGESQ + '/live/report/types' //获取举报的类目

export const CommentDel = MGESQ + '/comment/del' //删除评论

/*排行榜*/
export const RankTypeUrl = MGERANK + '/rank/list' // 榜单类型

export const RankDates = MGERANK + '/rank/dates' // 榜单日期

export const RankUsersUrl = MGERANK + '/rank/users' // 明星榜单

export const RankShopUrl = MGERANK + '/rank/goods' // 商品榜单

export const RankVideoUrl = MGERANK + '/rank/video' // 视频榜单

export const RankRulesUrl = MGERANK + '/rank/rules' //榜单规则

export const MtFeedInfoUrl = MGESQ + '/mt/feed/info'

export const FeedDraftDetail = MGESQ + '/feed/draft/detail' //图文草稿详情

export const FeedDraftPreview = MGESQ + '/feed/album/draft/preview' //图文草稿预览

export const checkUser = MGESQ + '/user/isExist' // 标签详情

export const collectAdd = MGECOM + '/collect/add'

export const collectDel = MGECOM + '/collect/del'


export const goodsDetail = MGESQ + '/cms/goods_detail'
export const subscribe = MGESQ + '/v2/feed/activity/appoint'
